const state = {
  options: {
    hid: null,
    date: null
  }
}

const mutations = {
  setOptions (state, options) {
    for (let key in state.options) {
      if (options.hasOwnProperty(key)) {
        state.options[key] = options[key]
      }
    }
  }
}

const actions = {
  updateOptions ({commit}, payload) {
    return new Promise(function (resolve) {
      commit('setOptions', payload)
      resolve()
    })
  }
}

const getters = {
  options: function (state) {
    return state.options
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
